// extracted by mini-css-extract-plugin
export default {"noDataText":"NoData_noDataText__3S9n0","withBorder":"NoData_withBorder__kFvEv"};